var Backbone = require('backbone');
var _ = require('lodash');
var $ = require('jquery');
var template = require('../templates/page.ejs');
var cssTemplate = require('../templates/css.ejs');
var HeaderView = require('../views/header');
var FooterView = require('../views/footer');

('use strict');

module.exports = Backbone.View.extend({
    className: 'container-fluid',
    events: {},
    /**
     *
     */
    initialize: function(options) {
        _.bindAll(this, 'render');

        this.cms = options.cms;
        this.voteOption = options.voteOption;
        this.router = options.router;
        this.uniqueId = options.uniqueId;
        this.lastId = null;

        console.info('page: ', this.cms);
        this.listenTo(this.cms, 'change', function() {
            console.info('inside page');
            _.bind(this.updateCSS, this, this.cms);
        });
    },
    /**
     *
     */
    render: function() {
        this.$el.html(template());

        var displayHeader = this.cms.get('text')['views_page_header'].display_header;
        var displayFooter = this.cms.get('text')['views_page_footer'].display_footer;

        if (displayHeader && displayHeader === 'true') {
            this.header = new HeaderView({
                cms: this.cms,
                voteOption: this.voteOption,
                model: this.cms.get('text').views_page_header
            });
            this.$('header').append(this.header.render().$el);
        }

        if (displayFooter && displayFooter === 'true') {
            this.footer = new FooterView({
                cms: this.cms,
                router: this.router
            });
            this.$('footer').append(this.footer.render().$el);
        }

        return this;
    },
    /**
     *
     */
    updateCSS: function(cms) {
        var text = cms.get('text');
        var design = text.design;
        var header = text.views_page_header;
        var footer = text.views_page_footer;
        var gridStyling = text.views_nominee_grid;
        var customCss = design.css;

        //create variables for custom CSS
        var templateVars = {
            uniqueId: this.uniqueId,
            header: _.extend( {}, customCss.header, header ),
            footer: _.extend( {}, customCss.footer, footer ),
            grid: _.extend( {}, customCss.grid, gridStyling ),
            voteButton: customCss.vote_button,
            customFonts: design.custom_fonts,
            closeButton: customCss.x_close_button,
            voteModal: customCss.vote_modal,
            emailButton: customCss.email_button,
            login: customCss.login,
            page: customCss.page_background,
            container: customCss.container_background,
            countdown: customCss.countdown,
            closed: customCss.closed_page,
            voteItem: customCss.vote_item,
            thanks: customCss.thanks,
            auth: customCss.auth
        };

        var randomId = 'style_' + Math.round(Math.random() * 1000000);
        var lastId = this.lastId;

        if (lastId) {
            console.info($('#' + this.lastId), $('#' + this.lastId).length);
            $('#' + this.lastId).remove();
        }

        var css = cssTemplate(templateVars);
        var style = $('<style />');

        style.prop('id', randomId)
            .append(css)
            .appendTo('head');

        this.lastId = randomId;
    },

    remove: function() {
        console.info(this.lastId);

        if (this.lastId) {
            console.info($('#' + this.lastId), $('#' + this.lastId).length);
            $('#' + this.lastId).remove();
        }

        if (this.header) {
            this.header.remove();
        }

        if (this.footer) {
            this.footer.remove();
        }

        Backbone.View.prototype.remove.call(this);
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/views/page.js
// module id = 215
// module chunks = 0